import React from 'react'
import { useCssHandles } from '../../../shared/hooks/useCssHandles'
import { Battery } from '../../../shared/types/battery'
import SimpleProductCard from './SimpleProductCard'

const CSS_HANDLES = [
  'relatedProducts',
  'relatedProductsTitle',
  'relatedProductsGrid'
] as const

interface RelatedProductsProps {
  relatedProducts: Battery[]
  isLoadingRelated: boolean
  relatedImageErrors: Record<string, boolean>
  onRelatedImageError: (productId: string) => void
}

const RelatedProducts: React.FC<RelatedProductsProps> = ({
  relatedProducts,
  isLoadingRelated,
  relatedImageErrors,
  onRelatedImageError
}) => {
  const handles = useCssHandles(CSS_HANDLES)

  if (relatedProducts.length === 0) {
    return null
  }

  return (
    <div className={`${handles.relatedProducts} mt-12`}>
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h2 className={`${handles.relatedProductsTitle} text-2xl font-bold text-gray-900 mb-6`}>
          Produtos Relacionados
        </h2>
        <p className="text-gray-600 mb-6">
          Que tal adicionar mais alguns produtos ao seu pedido?
        </p>
        {isLoadingRelated ? (
          <div className={`${handles.relatedProductsGrid} grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6`}>
            {Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className="bg-gray-100 rounded-lg border border-gray-200 animate-pulse h-64" />
            ))}
          </div>
        ) : (
          <div className={`${handles.relatedProductsGrid} grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6`}>
            {relatedProducts.map(product => (
              <SimpleProductCard
                key={product.id}
                product={product}
                imageError={relatedImageErrors[product.id] || false}
                onImageError={onRelatedImageError}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default RelatedProducts

